import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OtherHousesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"other_houses"}/>
}
